import { createApp } from 'vue'
import {AstraScrollUp } from '@platform/astra-vue'

import './styles.css'

document.addEventListener('DOMContentLoaded', () => {
  console.log('main:ready')

  const burger = document.querySelector('.navbar--main .navbar-burger')

  burger?.addEventListener('click', () => {
    const target = document.querySelector('.navbar--main .navbar-menu')
    burger.classList.toggle('is-active')
    target?.classList.toggle('is-active')
  })
})

createApp(AstraScrollUp).mount('#astra-scroll-up')
